import React from "react"
import styles from "./AudioIconBars.module.scss"

interface AudioIconBarsProps {
  style?: React.CSSProperties;
}

const AudioIconBars: React.FC<AudioIconBarsProps> = ({ style }) => {
  return (
    <div className={styles.AudioIconBars} style={style}>
      <div className={styles.Bar}></div>
      <div className={styles.Bar}></div>
      <div className={styles.Bar}></div>
    </div>
  );
};

export default AudioIconBars;
